<template>
	<div> 
		<div class="reset-box">
	    	<h3>重置信息</h3>
	    	<div style="padding-bottom: 20px;">
	    		<ul>
	    			<li v-for="(item,index) in location" @click="reset(item.SN,item.Name)">
	    				<p>
		    				<span>{{item.GroupName +' '+ item.Name}}</span><br/>
		    				<span v-html="getLocationState(item.Location.ResetStatus)"></span>
	    				</p> 
	    			</li>  
	    			  
	    		</ul>
	    	</div> 
	    	<button @click="okReset" style="background: #40DC23;color:#fff;">全部重置</button>
	    	<button @click="cancalReset">取消</button>
	    </div> 
	    <div class="reset-mask"></div>
    </div>
</template>

<script>
	export default {
		props:{ 
			location:{
				type:Array,
				default:[]
			}
		},
		data(){
			return { 
			}
		},
		created(){
			 
		},
		mounted(){ 
			
		},
		updated(){
			
		},
		computed: {
			getLocationState(){ 
				return function(state){
					switch(state){
						case 1: 
							return '未重置'
						break;
						case 2: 
							return '正在重置...'
						break;
						case 3: 
							return '定位器重置中...'
						break;
						case 4: 
							return '互救器重置中...'
						break;
						case 5: 
							return '<font style="color:#40DC23">重置成功</font>'
						break;
					} 
				}
			}
		},
		methods:{ 
			cancalReset(){ 
				this.$emit('cancalReset')
			},
			okReset(){
				this.$emit('okReset')
			},
			reset(sn,name){
				this.$emit('reset',sn,name)
			}
		} 
	}
</script>

<style scoped lang="less">
	.reset-mask{
		left:0;
		top:0;
		width:100%;
		height:100%;
		background: #000;
		opacity: .3;
		position: fixed;
		z-index: 1;
	}
	.reset-box{ 
		font-size: 18px;
		width:820px;
		height:540px;
		position: fixed;
		z-index: 2;
		top:50%;
		left:50%;
		margin-left:-410px;
		margin-top: -270px;
		border-radius: 6px;
		text-align: center;
		background: #fff;
		h3{
			border-radius: 6px 6px 0 0;
			padding:15px;  
			background-color:#40DC23; 
			color:#fff;
		}
		ul{ 
			min-height: 360px;
			padding:0 10px;
		}
		li{
			display: table;
			width:104px; 
			padding:7px 0;
			float: left;
			background-color: #eee;
			border:1px solid #E6E6E6;
			border-radius: 5px;
			margin:8px 5px; 
			font-size: 13px;
			cursor: pointer;
			p{
				display: table-cell;
				vertical-align: middle;
				span:first-child{
					font-size:16px;
					color:#333;
				};
			}
		} 
		button{
			float:right;
			width:130px;
			height:50px;
			border:0;
			border-radius: 4px;
			background: #fff; 
			margin:15px;
			color:#40DC23;
			border:1px solid #40DC23;
			cursor: pointer;
		} 
	}
	 
</style>